import { render, staticRenderFns } from "./addVendorReqeuest.vue?vue&type=template&id=0c636b4e"
import script from "./addVendorReqeuest.vue?vue&type=script&lang=js"
export * from "./addVendorReqeuest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports